import { store } from '@/state/store';
import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import { assert_array_includes, assert_type_string } from '@shared/asserts/utils_asserts';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

interface Payload {
  value: string;
  key: keyof STATE__ui;
  valid_values: string[];
}

export function store_local__ui_set_string(payload: Payload) {
  store.dispatch(LOCAL__ui_set_string(payload));
}

export const LOCAL__ui_set_string = (payload: Payload): PayloadAction<Payload> => ({
  type: ENUM__redux_action.UI_SET_STRING,
  payload,
});

export function INIT_LOCAL__ui_set_string(state: STATE__ui, action: PayloadAction<Payload>) {
  let { key, value, valid_values } = action.payload;

  if (valid_values.length > 0) {
    assert_array_includes(valid_values, value, { key, assert_type: ENUM__error_type.VALIDATION_INVALID_TYPE });
  }

  let value_old = state[key];

  assert_type_string(value);
  assert_array_includes(['undefined', 'string'], typeof value_old, { key, assert_type: ENUM__error_type.VALIDATION_INVALID_TYPE });

  (state as any)[key] = value;
}
